export const isString = (myVar: unknown) =>
  typeof myVar === 'string' || myVar instanceof String
export const uppercaseFirstLetter = (c: string) =>
  c.charAt(0).toUpperCase() + c.slice(1)
